<div class="trip-detail-popup-right">
  <img
    src="../../../assets/img/icons8-macos-close-60.png"
    class="close-icons"
    (click)="close()"
  />
</div>
<form class="admin-forms" [formGroup]="workorderForm">
  <div class="accordion-class">
    <h5>Edit Work Order</h5>
    <mat-divider></mat-divider>
  </div>
  <div *ngIf="!enabledetails" class="input-fileds-container">
    <div class="group driver-truck">
      <div class="row mtb">
        <div class="col-sm-3 class-name">
          <mat-label>Customer Name</mat-label>
        </div>
        <div class="col-sm-3 details">
          {{ user_id?.username || editWOData?.userInfo?.username }}
        </div>
        <div class="col-sm-3 class-name">
          <mat-label>Customer Mobile</mat-label>
        </div>
        <div class="col-sm-3 details">
          {{ user_id?.mobile || editWOData?.userInfo?.mobile }}
        </div>
      </div>

      <div class="row mtb">
        <div class="col-sm-6">
          <mat-form-field>
            <mat-label>Pick Up Location</mat-label>
            <input
              style="color: black; float: right"
              formControlName="from_complete_address"
              (change)="onInputPickUpchange()"
              #pickUpLocationSearchField
              matInput
              type="text"
              required
            />
            <span
              *ngIf="workorderForm.controls['from_complete_address'].value"
              class="material-icons clear-icon"
              matSuffix
              (click)="clearPickUpField()"
              >close</span
            >
            <mat-icon matPrefix>location_on</mat-icon>
            <mat-error>Please Enter Pickup Location</mat-error>
          </mat-form-field>
        </div>
        <div class="col-sm-6">
          <mat-form-field>
            <mat-label>Drop Off Location</mat-label>
            <input
              style="color: black; float: right"
              formControlName="to_complete_address"
              (change)="onDropChange()"
              #dropLocationSearchField
              matInput
              type="text"
              required
            />
            <span
              *ngIf="workorderForm.controls['to_complete_address'].value"
              class="material-icons clear-icon"
              (click)="clearDropUpField()"
              matSuffix
              >close</span
            >
            <mat-icon matPrefix>location_on</mat-icon>
            <mat-error>Please Enter Dropup Location</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row mtb">
        <div class="col-sm-4">
          <mat-form-field>
            <mat-label>Pick Up Date</mat-label>
            <input
              matInput
              placeholder="Pickup Date"
              [value]="workorderForm.get('pickup_date')?.value | date:'dd-MM-yyyy'"
              readonly
            />
          </mat-form-field>
        </div>
        <div class="col-sm-4">
          <mat-form-field>
            <mat-select
              dropLocationSearchField
              placeholder="Truck Category"
              formControlName="truck_category"
              (selectionChange)="gettruckCatg($event)"
              required
            >
              <mat-option
                *ngFor="let cat of truckCategory"
                value="{{ cat._id }}"
              >
                {{ cat.truck_category_name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-sm-4">
          <mat-form-field>
            <mat-label>DO - Total Ton's</mat-label>
            <input
              matInput
              appThreeDigitDecimalNumber
              formControlName="total_tons"
              required
            />
            <mat-error>Please Enter Do Total Ton's </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row mtb">
        <div class="col-sm-3">
          <mat-form-field>
            <mat-label>Price / Ton</mat-label>
            <input
              matInput
              appTwoDigitDecimaNumber
              formControlName="price_per_ton"
              (blur)="formatPricePerTon()"
              required
            />
            <mat-error>Please Enter Price Per Ton </mat-error>
          </mat-form-field>
        </div>
        <div class="col-sm-9 load_category">
          <p>Load Category:</p>
          <div
            class="load-details load-details-btn load-categorie"
            *ngFor="let item of loadCategory; let i = index"
          >
            <div
              [class.load-categorie-selected]="i == loadCategorySelectedindex"
            >
              <button
                id="getClick"
                (click)="loadCatChange(item.load_category, i)"
              >
                {{ editWOData.load_type ? item.load_category : "" }}
              </button>
            </div>
          </div>
        </div>

        <div class="row mtb">
          <!-- <div class="col-sm-3 class-name">
          <mat-label>Material Type</mat-label>
        </div> -->
          <div class="col-sm-3 class-name">
            <mat-label>Material Type:</mat-label>
          </div>
          <div class="col-sm-9">
            <mat-form-field>
              <mat-label>Select Material</mat-label>

              <mat-select formControlName="material_type">
                <mat-option
                  *ngFor="let item of materialDetails?.material_type"
                  [value]="item.name"
                >
                  {{ item.name }}
                </mat-option>
              </mat-select>
              <mat-error
                *ngIf="
                  loadCategorySelectedindex !== null && !materialTypeSelected
                "
                >Please select Material Type
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="row mtb">
        <div class="col-sm-6 bill_details">
          <h6>Billing Details</h6>
        </div>
        <div class="col-sm-6 bill_detail">
          <h6>Pickup & Dropoff Details</h6>
        </div>
      </div>
      <div class="row mtb">
        <div class="col-sm-6">
          <mat-form-field>
            <mat-label>Full Name</mat-label>
            <input matInput formControlName="username" required />
            <mat-error>Please Enter Name </mat-error>
          </mat-form-field>
        </div>
        <div class="col-sm-6">
          <mat-form-field>
            <mat-label>Pickup Contact</mat-label>
            <input matInput formControlName="pickup_name" required />
            <mat-error>Please Enter Pickup Contact</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row mtb">
        <div class="col-sm-6">
          <mat-form-field>
            <mat-label>Address Line 1</mat-label>
            <input matInput formControlName="address_line" required />
            <mat-error>Please Enter Address </mat-error>
          </mat-form-field>
        </div>
        <div class="col-sm-6">
          <mat-form-field>
            <mat-label>Mobile Number</mat-label>
            <input
              matInput
              formControlName="pickup_contact"
              minlength="10"
              maxlength="10"
              (keypress)="validateNumber($event)"
              required
            />
            <!-- <mat-error
              *ngIf="(ProfileFormControl['pickup_contact'].touched) && ProfileFormControl['pickup_contact'].errors?.['required']"
            >
              Mobile No is required</mat-error
            >
            <mat-error
              *ngIf="(ProfileFormControl['pickup_contact'].touched) && ProfileFormControl['pickup_contact'].errors?.['pattern']"
            >
              Please enter a valid mobile no</mat-error
            > -->
            <mat-error>Please Enter Mobile Number</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row mtb">
        <div class="col-sm-6">
          <mat-form-field>
            <mat-label>City</mat-label>
            <input matInput formControlName="city" />
            <mat-error>Please Enter City </mat-error>
          </mat-form-field>
        </div>
        <div class="col-sm-6">
          <mat-form-field>
            <mat-label>Dropoff Contact</mat-label>
            <input matInput formControlName="dropoff_name" required />
            <mat-error>Please Enter Dropoff Contact</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row mtb">
        <div class="col-sm-3">
          <mat-form-field>
            <mat-label>State</mat-label>
            <input matInput formControlName="state" required />
            <mat-error>Please Enter State Name</mat-error>
          </mat-form-field>
        </div>
        <div class="col-sm-3">
          <mat-form-field>
            <mat-label>Pincode</mat-label>
            <input
              matInput
              formControlName="pincode"
              minlength="6"
              maxlength="6"
              (keypress)="validateNumber($event)"
            />

            <mat-error>Please Enter Pincode</mat-error>
          </mat-form-field>
        </div>
        <div class="col-sm-6">
          <mat-form-field>
            <mat-label>Mobile Number</mat-label>
            <input
              matInput
              (keypress)="validateNumber($event)"
              formControlName="dropoff_contact"
              minlength="10"
              maxlength="10"
              required
            />

            <mat-error>Please Enter Mobile No</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row mtb">
        <div class="col-sm-6">
          <mat-form-field>
            <mat-label>GST no. (optional)</mat-label>
            <input
              matInput
              appAlphanumericOnly
              toUppercase
              formControlName="gst"
              maxlength="15"
            />
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3 d-flex align-items-center">
          <div class="">Payment Based on</div>
        </div>
        <div class="col-md-4">
          <div class="driver-truck">
            <mat-form-field appearance="fill">
              <mat-select
                formControlName="pay_as_load_quantity"
                (selectionChange)="selectLoadedQty($event.value)"
              >
                <mat-option value="loaded_quantity">Loaded Qty</mat-option>
                <mat-option value="unloaded_quantity">Unloaded Qty</mat-option>
              </mat-select>
              <mat-error>Please select Payment based on</mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row buttons">
    <div class="col-sm-2">
      <button
        type="submit"
        class="button buttonBlue"
        [class.spinner]="loading"
        (click)="onEditSave($event)"
      >
        Submit
      </button>
    </div>
  </div>
</form>
